import { IFeatureOnboardingScreen, OnboardingStorage } from 'state/onboarding/types';
import { SyncStorageKey, syncStorage } from 'utils/environment/sync-storage';

export const addOrUpdateScreenState = (
  featureOnboardingTriggerRule: string,
  featureOnboardingScreen: IFeatureOnboardingScreen,
  route?: string
) => {
  const onboardingState = syncStorage.getObject<OnboardingStorage>(SyncStorageKey.ONBOARDING_STATE);
  if (onboardingState) {
    const docIdx = onboardingState.onboardingDocs.findIndex(
      doc => doc.id === featureOnboardingTriggerRule
    );
    if (docIdx === -1) {
      onboardingState.onboardingDocs.push({ id: featureOnboardingTriggerRule, screens: [] });
    }

    onboardingState.onboardingDocs = onboardingState.onboardingDocs.map(doc => {
      if (doc.id === featureOnboardingTriggerRule) {
        const screenIdx = doc.screens.findIndex(
          screen => screen.id === featureOnboardingScreen?.id
        );
        if (screenIdx !== -1) {
          doc.screens[screenIdx].completed = true;
        } else if (featureOnboardingScreen?.id) {
          doc.screens.push({
            id: featureOnboardingScreen?.id,
            completed: !!route,
          });
        }
      }
      return doc;
    });

    syncStorage.setObject(SyncStorageKey.ONBOARDING_STATE, onboardingState);
  } else {
    const onboardingState: OnboardingStorage = {
      loyaltyEnrolled: false,
      onboardingDocs: [
        {
          id: featureOnboardingTriggerRule,
          screens: [
            {
              id: featureOnboardingScreen?.id ?? '',
              completed: true,
            },
          ],
        },
      ],
    };
    syncStorage.setObject(SyncStorageKey.ONBOARDING_STATE, onboardingState);
  }
};
